import * as PIXI from 'pixi.js'
import PreloaderController from './base/preloader/BasePreloaderController';
import ScaleManager from './ScaleManager'
import GlobalDispatcher from "./events/GlobalDispatcher";
import PreloaderView from "./base/preloader/BasePreloaderView";
//import AdaptiveSizeManager from "./AdaptiveSizeManager";
import {TweenMax} from "gsap/TweenMax";
import LocalizeTextField from "Engine/base/localization/LocalizeTextField";
import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";

export default class BaseGame {

    constructor() {
        FlashLib.TextField = LocalizeTextField;

        TweenMax.ticker.useRAF(false);
        this.preloaderController = null;
        this.preloaderView = null;

        this.init();
        this.addListeners();
    }

    init() {
        this.initStartParams();
        this.initScaleManager();
        this.createGame();
        this.createPreloader();
        this.initStartClasses();
    }

    addListeners() {
        GlobalDispatcher.add('scaleManager:resize', this.onGameResized, this);
    }

    onGameResized(event) {
    }

    initStartClasses() {
        //this.serverManager = new SlotServerManager();
        //StatesManager.setStatesConfig(StatesConfig);
        //GameModel.init();
    }

    linkToTweenMax() {
        this.app.ticker.stop();
        TweenMax.ticker.addEventListener('tick', () => {
            this.app.ticker.update();
        });
    }

    linkToPixi() {
        TweenMax.ticker.sleep();
        this.app.ticker.add(() => {
            TweenMax.ticker.tick();
        });
    }

    initStartParams() {
        this.preloaderTimeout = 1000;
        this.gameSize = {
            width: 960,
            height: 536
        };
        this.baseSize = {
            width: window.innerWidth,
            height: window.innerHeight,
            offsetY: 0,
            ratio: 960 / 536
        };
        this.scaleData = {
            type: 'css',
            app: this.app,
            safeWidth: 960,
            safeHeight: 536,
            fullSize: true,
            gameSize: this.gameSize
        };
    }

    createGame() {
        this.container = document.getElementById('container');
        //PIXI.utils.skipHello();
        this.applicationOptions = {
            /*antialias: true,
            forceFXAA: true,*/
            //forceCanvas: true,
            backgroundColor: 0x0,
            //backgroundColor: 0x4597B7,
            //legacy: true,
            width: ScaleManager.currentSizes.width,
            height: ScaleManager.currentSizes.width / ScaleManager.currentSizes.graphicsRatio
        };
        this.app = new PIXI.Application(this.applicationOptions);
        this.app.renderer.plugins.interaction.moveWhenInside = true;
        this.app.view.id = 'gameCanvas';
        this.container.appendChild(this.app.view);

        this.scaleData.app = this.app;
        ScaleManager.onResize();
    }

    createPreloader() {
        this.preloaderController = new PreloaderController();
        this.preloaderController.on('preloaderLoadingComplete', this.onLoadingPreloaderComplete, this);
        this.preloaderController.on('gameLoadingComplete', this.onLoadingComplete, this);

        this.preloaderView = new PreloaderView(this.gameSize);
        this.app.stage.addChild(this.preloaderView);
    }

    initScaleManager() {
        ScaleManager.init(this.scaleData);
    }

    onLoadingPreloaderComplete() {
        ScaleManager.onResize();
    }

    onLoadingComplete() {
        setTimeout(() => {
            //this.hidePreloader();
            this.constructGame();
        }, this.preloaderTimeout);
    }

    hidePreloader() {
        this.preloaderView.destroy({children: true});
    }

    constructGame() {
        //this.main = new Main();
        this.app.stage.addChildAt(this.main, 0);
        GlobalDispatcher.dispatch('game:gameStarted');
        ScaleManager.onResize();
        this.hidePreloader();
        this.linkToTweenMax();
    }
}

//export default new BaseGame()
